/**
 * Restores the selected id from the _rmlFolder property of the given context.
 */ function restoreMediaViewSelection(folderId, treeStore, bridge, callback) {
    if (folderId === undefined) {
        return;
    }
    const node = treeStore.getTreeItemById(folderId);
    if (node && node.visible && treeStore.selectedId !== folderId) {
        node.setter((folderNode)=>{
            folderNode.setSelected(true);
        });
    }
    if (!node || !node.$visible) {
        bridge?.selectFolder("all");
    } else {
        callback?.(node);
    }
}
export { restoreMediaViewSelection };
